import { createLogic, StandardAction } from "redux-logic";
import {
  FETCH_REVIEW_BOX,
  clearState,
  setReviewBox, toggleScan, setAction, setIPackBoxBarcode, setTransitBoxEmpty, RESTART_BOX_DELIVERY, fetchReviewBox, setRestartDeliveryModalOpen, setBoxReplacementNeeded, setBoxReplacementError
} from "../reducers/autostoreModeReducer";
import { setError, setLoadingStatus } from "../reducers/applicationStateReducer";
import { PayloadWrapper } from "../types/PayloadWrapper";
import Endpoints from "../../autostore/AutoStoreEndpoints";
import { ActionStates, IAutoStoreBoxReview, IAutoStoreControlAppState, IAutoStoreFetchBoxReviewRequest, IAutoStoreRestartBoxDeliveryRequest } from "../../../components/AutoStoreControlApp/IAutoStoreControlAppState";


const fetchAutoStoreReviewBoxLogic = createLogic({
  type: FETCH_REVIEW_BOX,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, PayloadWrapper<IAutoStoreFetchBoxReviewRequest>
      >;
    },
    dispatch,
    done
  ) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    dispatch(toggleScan(new PayloadWrapper(true)));
    dispatch(setBoxReplacementNeeded(new PayloadWrapper(false)));
    dispatch(setBoxReplacementError(new PayloadWrapper(null)));
    await Endpoints.getAutoStoreReviewBox(action.payload.value.barcode, action.payload.value.forceTransit)
      .then((rb: IAutoStoreBoxReview | null) => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        dispatch(toggleScan(new PayloadWrapper(false)));
        dispatch(setIPackBoxBarcode(new PayloadWrapper(action.payload.value.barcode)));
        if (!rb) {
          dispatch(clearState());
          dispatch(setError({ message: "Kunde inte hitta order!", visible: true, errorType: 1 }));
          done();
        } else {
          if (rb.destinationTransitShelf != null) {
            dispatch(setReviewBox(new PayloadWrapper(rb)));
          } else {
            dispatch(setAction(new PayloadWrapper(ActionStates.COMPLETE_BOX)));
            dispatch(setReviewBox(new PayloadWrapper(rb)));
            dispatch(toggleScan(new PayloadWrapper(false)));
            dispatch(setTransitBoxEmpty(new PayloadWrapper(false)));
          }
          done();
        }
      })
      .catch((ex: any) => {
        console.log(ex);
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        dispatch(toggleScan(new PayloadWrapper(false)));
        dispatch(clearState());
        dispatch(setError({ message: "Kunde inte ladda order: " + ex?.message, visible: true, errorType: 1 }));
        done();
      });
  },
});

const restartDeliveryAutoStoreBoxLogic = createLogic({
  type: RESTART_BOX_DELIVERY,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, PayloadWrapper<IAutoStoreRestartBoxDeliveryRequest>>;
    },
    dispatch,
    done
  ) {
    dispatch(setBoxReplacementNeeded(new PayloadWrapper(false)));
    dispatch(setBoxReplacementError(new PayloadWrapper(null)));
    var appState = getState().autostoreModeReducer as IAutoStoreControlAppState;
    if (!appState.boxReview?.isAframeFinalized) {
      dispatch(setLoadingStatus(new PayloadWrapper(true)));
      dispatch(toggleScan(new PayloadWrapper(true)));
      await Endpoints.restartDelivery(action.payload.value.invoiceNumber)
        .then((rb: any) => {
          dispatch(setRestartDeliveryModalOpen(new PayloadWrapper(false)));
          dispatch(fetchReviewBox(new PayloadWrapper({ barcode: action.payload.value.barcode, forceTransit: false })));
          done();
        })
        .catch((ex: any) => {
          console.log(ex);
          dispatch(setLoadingStatus(new PayloadWrapper(false)));
          dispatch(toggleScan(new PayloadWrapper(false)));
          dispatch(clearState());
          dispatch(setError({ message: "Kunde inte starta om order: " + ex?.message, visible: true, errorType: 1 }));
          done();
        });
    }else {
      //reset verified quantity if sortbox is aframe-finalized, no need to reset delivery
      appState.boxReview.sortBoxModel.sortBoxItems.forEach(x=> x.verifiedQuantity = 0);
      dispatch(setReviewBox(new PayloadWrapper(appState.boxReview)));
      dispatch(setRestartDeliveryModalOpen(new PayloadWrapper(false)));
    }
  },
});

export { fetchAutoStoreReviewBoxLogic, restartDeliveryAutoStoreBoxLogic };
